module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }, [_c('router-link', {
    staticClass: "fl-button grey",
    attrs: {
      "to": {
        path: '/access_levels/'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "fl-button",
    attrs: {
      "disabled": _vm.is_save,
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])], 1), _vm._v(" "), _c('h1', [_vm._v("Access Level")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "name",
      "label": "Megnevezés",
      "errors": _vm.errors,
      "name": "name"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "disabled": !_vm.form.erasable,
      "id": "alias",
      "label": "Alias",
      "regexp_filter": "[a-zA-Z_0-9]+",
      "errors": _vm.errors,
      "name": "alias"
    },
    model: {
      value: (_vm.form.alias),
      callback: function($$v) {
        _vm.$set(_vm.form, "alias", $$v)
      },
      expression: "form.alias"
    }
  }), _vm._v(" "), _c('select2', {
    attrs: {
      "multi": "true",
      "errors": _vm.errors,
      "label": "Csoportok",
      "name": "groups",
      "id": "groups",
      "options": _vm.groups
    },
    model: {
      value: (_vm.form.group_ids),
      callback: function($$v) {
        _vm.$set(_vm.form, "group_ids", $$v)
      },
      expression: "form.group_ids"
    }
  }), _vm._v(" "), _c('toggle', {
    attrs: {
      "id": "barcode_enabled",
      "label": "QR kód engedélyezve",
      "errors": _vm.errors,
      "name": "barcode_enabled"
    },
    model: {
      value: (_vm.form.barcode_enabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "barcode_enabled", $$v)
      },
      expression: "form.barcode_enabled"
    }
  }), _vm._v(" "), _c('textareabox', {
    attrs: {
      "id": "comment",
      "label": "Megjegyzés",
      "errors": _vm.errors,
      "name": "comment"
    },
    model: {
      value: (_vm.form.comment),
      callback: function($$v) {
        _vm.$set(_vm.form, "comment", $$v)
      },
      expression: "form.comment"
    }
  })], 1), _vm._v(" "), (_vm.form.elements.length > 0) ? _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, _vm._l((_vm.form.elements), function(item, i) {
    return (item.deleted == undefined) ? _c('div', {
      staticClass: "row",
      class: {
        'row-disabled': _vm.form.params != null && _vm.form.params.tesa_room != undefined
      }
    }, [_c('div', {
      staticClass: "col-xs-2"
    }, [_c('comboboxV2', {
      attrs: {
        "id": 'element_id_' + i,
        "label": "Eszköz",
        "errors": _vm.errors,
        "name": 'element_id_' + i,
        "options": _vm.elements
      },
      model: {
        value: (item.element_id),
        callback: function($$v) {
          _vm.$set(item, "element_id", $$v)
        },
        expression: "item.element_id"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2"
    }, [_c('comboboxV2', {
      attrs: {
        "id": 'schedule_group_id_allow_' + i,
        "label": "Schedule engedélyezett",
        "errors": _vm.errors,
        "name": 'schedule_group_id_allow_' + i,
        "options": _vm.schedules
      },
      model: {
        value: (item.schedule_group_id_allow),
        callback: function($$v) {
          _vm.$set(item, "schedule_group_id_allow", $$v)
        },
        expression: "item.schedule_group_id_allow"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2"
    }, [_c('comboboxV2', {
      attrs: {
        "id": 'schedule_group_id_deny_' + i,
        "label": "Schedule tiltott",
        "errors": _vm.errors,
        "name": 'schedule_group_id_deny_' + i,
        "options": _vm.schedules
      },
      model: {
        value: (item.schedule_group_id_deny),
        callback: function($$v) {
          _vm.$set(item, "schedule_group_id_deny", $$v)
        },
        expression: "item.schedule_group_id_deny"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2"
    }, [_vm._m(0, true), _vm._v(" "), _c('button', {
      staticClass: "button small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeElement(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])]) : _vm._e()
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: {
      'row-disabled': _vm.form.params != null && _vm.form.params.tesa_room != undefined
    }
  }, [_c('div', {
    staticClass: "col-xs-2"
  }, [_c('comboboxV2', {
    attrs: {
      "id": "new_element_id",
      "label": "Eszköz",
      "errors": _vm.errors,
      "name": "new_element_id",
      "options": _vm.elements
    },
    model: {
      value: (_vm.new_element.element_id),
      callback: function($$v) {
        _vm.$set(_vm.new_element, "element_id", $$v)
      },
      expression: "new_element.element_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('comboboxV2', {
    attrs: {
      "id": "new_schedule_group_id_allow",
      "label": "Schedule engedélyezett",
      "errors": _vm.errors,
      "name": "new_schedule_group_id_allow",
      "options": _vm.schedules
    },
    model: {
      value: (_vm.new_element.schedule_group_id_allow),
      callback: function($$v) {
        _vm.$set(_vm.new_element, "schedule_group_id_allow", $$v)
      },
      expression: "new_element.schedule_group_id_allow"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('comboboxV2', {
    attrs: {
      "id": "new_schedule_group_id_deny",
      "label": "Schedule tiltott",
      "errors": _vm.errors,
      "name": "schedule_group_id_deny",
      "options": _vm.schedules
    },
    model: {
      value: (_vm.new_element.schedule_group_id_deny),
      callback: function($$v) {
        _vm.$set(_vm.new_element, "schedule_group_id_deny", $$v)
      },
      expression: "new_element.schedule_group_id_deny"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "button small orange",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addElement
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.query.accesslevelID != undefined),
      expression: "$route.query.accesslevelID != undefined"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h2', [_vm._v("Kártyák")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('inputbox', {
    attrs: {
      "id": "owner_name",
      "label": "Kártya tulajdonos",
      "name": "owner_name"
    },
    on: {
      "input": _vm.searchCards
    },
    model: {
      value: (_vm.search_cards.owner_name),
      callback: function($$v) {
        _vm.$set(_vm.search_cards, "owner_name", $$v)
      },
      expression: "search_cards.owner_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('inputbox', {
    attrs: {
      "regexp_filter": "[0-9]+",
      "id": "card_number",
      "label": "Kártyaszám",
      "name": "card_number"
    },
    on: {
      "input": _vm.searchCards
    },
    model: {
      value: (_vm.search_cards.card_number),
      callback: function($$v) {
        _vm.$set(_vm.search_cards, "card_number", $$v)
      },
      expression: "search_cards.card_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('inputbox', {
    attrs: {
      "regexp_filter": "[a-zA-Z0-9]+",
      "maxlength": "8",
      "id": "rfid",
      "label": "RFID",
      "name": "rfid"
    },
    on: {
      "input": _vm.searchCards
    },
    model: {
      value: (_vm.search_cards.rfid),
      callback: function($$v) {
        _vm.$set(_vm.search_cards, "rfid", $$v)
      },
      expression: "search_cards.rfid"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('inputbox', {
    attrs: {
      "regexp_filter": "[a-zA-Z0-9]+",
      "maxlength": "10",
      "id": "plate_number",
      "label": "Rendszám",
      "name": "plate_number"
    },
    on: {
      "input": _vm.searchCards
    },
    model: {
      value: (_vm.search_cards.plate_number),
      callback: function($$v) {
        _vm.$set(_vm.search_cards, "plate_number", $$v)
      },
      expression: "search_cards.plate_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "button with-icon",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchCards
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("Keresés")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "table-with-title"
  }, [_c('h2', [_vm._v("Access Levelhez rendelt kártyák")]), _vm._v(" "), _c('table', {
    staticClass: "list"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.access_level_cards), function(card) {
    return _c('tr', {
      key: card.card_number,
      style: ({
        backgroundColor: card.active == '1' ? 'inherit' : '#eee'
      }),
      attrs: {
        "title": card.active == '0' ? 'Ez a kártya inaktív' : ''
      }
    }, [_c('td', [_vm._v(_vm._s(card.owner_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(card.card_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(card.rf_id))]), _vm._v(" "), _c('td', {
      staticClass: "buttons"
    }, [_c('router-link', {
      staticClass: "small-button",
      attrs: {
        "to": {
          path: '/card/edit/',
          query: {
            cardID: card.element_id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-alt"
    })]), _vm._v(" "), _c('button', {
      staticClass: "small-button red",
      attrs: {
        "title": "Jelenlegi Access Level megvonása a kártyától"
      },
      on: {
        "click": function($event) {
          return _vm.removeAccessLevel(card.element_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus"
    })])], 1)])
  }), 0)]), _vm._v(" "), (_vm.access_level_cards.length > 0) ? _c('pagination', {
    attrs: {
      "showcombo": "1",
      "compact": "1",
      "limit": _vm.pagination_access_level_cards.limit,
      "amount": _vm.pagination_access_level_cards.amount
    },
    on: {
      "pageChanged": _vm.getAccessLevelCards
    },
    model: {
      value: (_vm.pagination_access_level_cards.page),
      callback: function($$v) {
        _vm.$set(_vm.pagination_access_level_cards, "page", $$v)
      },
      expression: "pagination_access_level_cards.page"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "table-with-title"
  }, [_c('h2', [_vm._v("Access Levelhez nem rendelt kártyák")]), _vm._v(" "), _c('table', {
    staticClass: "list"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.non_access_level_cards), function(card) {
    return _c('tr', {
      key: card.card_number,
      style: ({
        backgroundColor: card.active == '1' ? 'inherit' : '#eee'
      }),
      attrs: {
        "title": card.active == '0' ? 'Ez a kártya inaktív' : ''
      }
    }, [_c('td', [_vm._v(_vm._s(card.owner_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(card.card_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(card.rf_id))]), _vm._v(" "), _c('td', {
      staticClass: "buttons"
    }, [_c('router-link', {
      staticClass: "small-button",
      attrs: {
        "to": {
          path: '/card/edit/',
          query: {
            cardID: card.element_id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-alt"
    })]), _vm._v(" "), _c('button', {
      staticClass: "small-button green",
      staticStyle: {
        "backround-color": "lime"
      },
      attrs: {
        "title": "Jelenlegi Access Level kártyához rendelése"
      },
      on: {
        "click": function($event) {
          return _vm.addAccessLevel(card.element_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })])], 1)])
  }), 0)]), _vm._v(" "), (_vm.non_access_level_cards.length > 0) ? _c('pagination', {
    attrs: {
      "showcombo": "1",
      "compact": "1",
      "limit": _vm.pagination_non_access_level_cards.limit,
      "amount": _vm.pagination_non_access_level_cards.amount
    },
    on: {
      "pageChanged": _vm.getNonAccessLevelCards
    },
    model: {
      value: (_vm.pagination_non_access_level_cards.page),
      callback: function($$v) {
        _vm.$set(_vm.pagination_non_access_level_cards, "page", $$v)
      },
      expression: "pagination_non_access_level_cards.page"
    }
  }) : _vm._e()], 1)])])])])])], 1), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProgressInfo', {
    attrs: {
      "show": _vm.is_save
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-label"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-label"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Tulajdonos")]), _vm._v(" "), _c('th', [_vm._v("Kártyaszám")]), _vm._v(" "), _c('th', [_vm._v("RFID")]), _vm._v(" "), _c('th')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Tulajdonos")]), _vm._v(" "), _c('th', [_vm._v("Kártyaszám")]), _vm._v(" "), _c('th', [_vm._v("RFID")]), _vm._v(" "), _c('th')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d8a1a96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/access_level.vue
// module id = 282
// module chunks = 0